import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import ShowAlert from "../components/alert.component";
import {AvailableApps} from "../views/auth/Login/availableapps.view"

/**
 * Login Component ( full view Login component, render a login
 * form and make a post request for user verification  )
 *
 * @export Class Component
 * @class Alert
 * @extends {Component}
 * @returns Redux connect
 */

const Alert = (props) => {

  const { history } = props
  const [isNewUser] = useState(history.location?.state?.messageType);

  const handleClick = () => {
    const pageName = history.location?.state?.pagename;
    if (pageName !== '') {
      pushToHistory(pageName);
    } else {
      pushToHistory();
    }
  }

  useEffect(() => {
    if ((!history.location?.state) || history.location?.state?.message === null) {
      pushToHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Navigate to the route by changing the history 
   * @param {*} path by default /Login
   */
  const pushToHistory = (path = '/Login') => {
    history.push(path)
  }

  return isNewUser === "ACCOUNT_ACTIVATED" ? (
    <AvailableApps
      {...props}
      location={{
        ...props.location,
        state: {
          ...props.location?.state,
          userData: {
            ...props.location?.state?.userData,
            isNewUser: isNewUser,
          },
        },
      }}
    />
  ) : (
    <ShowAlert
      value={history.location?.state?.message}
      onClick={handleClick}
    />
  );
};
const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(Alert);
